module.exports = "## Semantic\n\nSemantic tokens play specific roles in our UI and gives us flexibility in different themes.\n"